export const LocationInitialData = {
  payload: {
    name: "",
    longitude: "",
    latitude: "",
    address: "",
  },
};
